var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import ndarray from "ndarray";
import regl_ from "regl";
import { MAX_REPEATS_X, MAX_REPEATS_Y } from "./constants";
import { float as f, range, slope } from "./utils";
/**
 * Compute a density heatmap.
 * @param data The time series data as an ndarray.
 * @param attribute The attribute of data : [minX, maxX, minY, maxY]
 * @param binX Configuration for the binning along the time dimension.
 * @param binY Configuration for the binning along the value dimension.
 * @param canvas The canvas for the webgl context and for debug output.
 * @param gaussianKernel
 * @param lineWidth
 * @param tangentExtent
 * @param normalExtent
 * @param doNormalize
 * @param scaleOption
 */
export default function (data, attribute, binX, binY, canvas, gaussianKernel, lineWidth, tangentExtent, normalExtent, doNormalize, scaleOption) {
    if (lineWidth === void 0) { lineWidth = 1; }
    if (tangentExtent === void 0) { tangentExtent = 0; }
    if (normalExtent === void 0) { normalExtent = 0; }
    if (doNormalize === void 0) { doNormalize = 1; }
    return __awaiter(this, void 0, void 0, function () {
        function colorMask(i) {
            var mask = [false, false, false, false];
            mask[i % 4] = true;
            return mask;
        }
        var _a, numSeries, maxDataPoints, debugCanvas, heatmapWidth, heatmapHeight, gaussianIndexOffset, regl, maxRenderbufferSize, maxRepeatsX, maxRepeatsY, repeatsX, repeatsY, reshapedWidth, reshapedHeight, drawLine, drawFlatLine, computeBase, gaussian, sum, normalize, mergeBufferHorizontally, mergeBufferVertically, drawTexture, filterByAngles, filterByValues, findMax, calWeight, linesBuffer, gaussianBuffer, flatLinesBuffer, filterAngleBuffer, sumsBuffer, resultBuffer, preMergedBuffer, heatBuffer, maxValueBuffer, batchSize, series, finishedSeries, b, lines, row, i, valueLength, maxDensity, indexCache;
        return __generator(this, function (_b) {
            _a = __read([data.length, attribute[1]], 2), numSeries = _a[0], maxDataPoints = _a[1];
            debugCanvas = !!canvas;
            heatmapWidth = Math.floor((binX.stop - binX.start) / binX.step);
            heatmapHeight = Math.floor((binY.stop - binY.start) / binY.step);
            if (gaussianKernel === undefined) {
                gaussianKernel = [
                    [1, 2, 1],
                    [2, 8, 2],
                    [1, 2, 1],
                ];
            }
            if (scaleOption === undefined) {
                scaleOption = {
                    xRatio: 1,
                    yRatio: 1,
                    xOffset: 0,
                    yOffset: 0,
                };
            }
            if (gaussianKernel.find(function (gaussianRow) { return gaussianRow.length != gaussianKernel.length; })) {
                throw new Error("The input Gaussian kernal should be square matrix.");
            }
            if (gaussianKernel.length % 2 == 0) {
                throw new Error("The input Gaussian kernal size should be odd.");
            }
            gaussianIndexOffset = Math.round((gaussianKernel.length - 1) / 2);
            console.info("Heatmap size: " + heatmapWidth + "x" + heatmapHeight);
            console.info("GaussianKernelSize: " + gaussianKernel.length + "x" + gaussianKernel.length);
            regl = regl_({
                canvas: canvas || document.createElement("canvas"),
                extensions: ["OES_texture_float"],
                attributes: { preserveDrawingBuffer: true },
            });
            regl.on("lost", function () {
                alert("Out of GPU memory, charts will be destroyed!");
            });
            maxRenderbufferSize = Math.min(regl.limits.maxRenderbufferSize, 4096);
            maxRepeatsX = Math.floor(maxRenderbufferSize / heatmapWidth);
            maxRepeatsY = Math.floor(maxRenderbufferSize / heatmapHeight);
            repeatsX = Math.min(maxRepeatsX, Math.ceil(numSeries / 4 - 1e-6), MAX_REPEATS_X);
            repeatsY = Math.min(maxRepeatsY, Math.ceil(numSeries / (repeatsX * 4)), MAX_REPEATS_Y);
            console.info("Can repeat " + maxRepeatsX + "x" + maxRepeatsY + " times. Repeating " + repeatsX + "x" + repeatsY + " times.");
            reshapedWidth = heatmapWidth * repeatsX;
            reshapedHeight = heatmapHeight * repeatsY;
            console.info("Canvas size " + reshapedWidth + "x" + reshapedHeight + ". Tangent Gaussian size " + tangentExtent + ". Normal Gaussian size " + f(normalExtent) + ". Line width " + lineWidth + ". MaxX " + binX.stop + ". MaxY " + binY.stop);
            drawLine = regl({
                vert: "\n    precision mediump float;\n      \n    attribute float time;\n    attribute float value;\n  \n    uniform float maxX;\n    uniform float maxY;\n    uniform float column;\n    uniform float row;\n  \n    void main() {\n      float repeatsX = " + f(repeatsX) + ";\n      float repeatsY = " + f(repeatsY) + ";\n  \n      // time and value start at 0 so we can simplify the scaling\n      float x = column / repeatsX + time / (maxX * repeatsX);\n      \n      // move up by 0.3 pixels so that the line is guaranteed to be drawn\n      float yOffset = row / repeatsY + 0.3 / " + f(reshapedHeight) + ";\n      // squeeze by 0.6 pixels\n      float squeeze = 1.0 - 0.6 / " + f(heatmapHeight) + ";\n      float yValue = value / (maxY * repeatsY) * squeeze;\n      float y = yOffset + yValue;\n  \n      // squeeze y by 0.3 pixels so that the line is guaranteed to be drawn\n      float yStretch = 2.0 - 0.6 / " + f(reshapedHeight) + ";\n  \n      // scale to [-1, 1]\n      gl_Position = vec4(\n        2.0 * (x - 0.5),\n        2.0 * (y - 0.5),\n        0, 1);\n    }",
                frag: "\n    precision mediump float;\n    varying vec4 uv;\n  \n    void main() {\n      // we will control the color with the color mask\n      gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);\n    }",
                uniforms: {
                    maxX: regl.prop("maxX"),
                    maxY: regl.prop("maxY"),
                    column: regl.prop("column"),
                    row: regl.prop("row"),
                },
                attributes: {
                    time: regl.prop("times"),
                    value: regl.prop("values"),
                },
                colorMask: regl.prop("colorMask"),
                depth: { enable: false, mask: false },
                count: regl.prop("count"),
                primitive: "line strip",
                lineWidth: function () { return 1; },
                framebuffer: regl.prop("out"),
            });
            drawFlatLine = regl({
                vert: "\n        precision mediump float;\n\n        attribute float value;\n        attribute float time;\n\n        uniform float maxX;\n        uniform float maxY;\n        uniform float lineIdx;\n\n        varying float v;\n\n        void main() {\n          v = value / maxY;\n\n          vec2 position = vec2(time / maxX, (floor(lineIdx / 4.0) + 0.5) / ceil(" + f(data.length) + " / 4.0));\n\n          // scale to [-1, 1]\n          gl_Position = vec4(\n            2.0 * (position.x - 0.5),\n            2.0 * (position.y - 0.5),\n            0, 1);\n        }",
                frag: "\n        precision mediump float;\n\n        varying float v;\n      \n        void main() {\n          gl_FragColor = vec4(v);\n        }",
                uniforms: {
                    maxX: regl.prop("maxX"),
                    maxY: regl.prop("maxY"),
                    lineIdx: regl.prop("lineIdx"),
                },
                attributes: {
                    value: regl.prop("values"),
                    time: regl.prop("times"),
                },
                colorMask: regl.prop("colorMask"),
                // additive blending
                blend: {
                    enable: true,
                    func: {
                        srcRGB: "one",
                        srcAlpha: 1,
                        dstRGB: "one",
                        dstAlpha: 1,
                    },
                    equation: {
                        rgb: "add",
                        alpha: "add",
                    },
                    color: [0, 0, 0, 0],
                },
                depth: { enable: false, mask: false },
                count: regl.prop("count"),
                primitive: "line strip",
                lineWidth: function () { return 1; },
                framebuffer: regl.prop("flatOut"),
            });
            computeBase = {
                vert: "\n        precision mediump float;\n      \n        attribute vec2 position;\n        varying vec2 uv;\n      \n        void main() {\n          uv = 0.5 * (position + 1.0);\n          gl_Position = vec4(position, 0, 1);\n        }",
                attributes: {
                    position: [-4, -4, 4, -4, 0, 4],
                },
                depth: { enable: false, mask: false },
                count: 3,
            };
            gaussian = regl(__assign(__assign({}, computeBase), { frag: "\n      precision mediump float;\n    \n      uniform sampler2D buffer;\n    \n      varying vec2 uv;\n    \n      vec4 getColor(int offsetX, int offsetY) {\n        const int canvasWidth = " + reshapedWidth + ";\n        const int canvasHeight = " + reshapedHeight + ";\n        const int sampleWidth = " + heatmapWidth + ";\n        const int sampleHeight = " + heatmapHeight + ";\n    \n        int currentX = int(uv.x * float(canvasWidth) + 1e-1);\n        int currentY = int(uv.y * float(canvasHeight) + 1e-1);\n        int refX = currentX + offsetX;\n        int refY = currentY + offsetY;\n    \n        if (currentX / sampleWidth == refX / sampleWidth && currentY / sampleHeight == refY / sampleHeight && refX >= 0 && refY >= 0) {\n          vec2 offsetPixel = vec2(float(offsetX), float(offsetY)) / vec2(float(canvasWidth), float(canvasHeight));\n          return texture2D(buffer, uv + offsetPixel);\n        } else {\n          return vec4(0.0, 0.0, 0.0, 0.0);\n        }\n      }\n    \n      void main() {\n        gl_FragColor = " + gaussianKernel
                    .map(function (gaussianRow, offsetY) {
                    return gaussianRow
                        .map(function (kernelValue, offsetX) {
                        return "getColor(" + (gaussianIndexOffset - offsetX) + ", " + (offsetY -
                            gaussianIndexOffset) + ") * " + f(kernelValue);
                    })
                        .join(" + ");
                })
                    .join(" + ") + ";\n      }\n    ", uniforms: {
                    buffer: regl.prop("buffer"),
                }, framebuffer: regl.prop("out") }));
            sum = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n        varying vec2 uv;\n      \n        void main() {\n          float texelRowStart = floor(uv.y * " + f(repeatsY) + ") / " + f(repeatsY) + ";\n          float texelColumnStart = floor(uv.x * " + f(repeatsX) + ") / " + f(repeatsX) + ";\n      \n          " + (doNormalize !== 2
                    ? "\n          // normalize by the column\n          vec4 sum = vec4(0.0);\n          for (float j = 0.0; j < " + f(heatmapHeight) + "; j++) {\n            float texelRow = texelRowStart + (j + 0.5) / " + f(reshapedHeight) + ";\n            vec4 value = texture2D(buffer, vec2(uv.x, texelRow));\n            sum += value;\n          }\n          "
                    : "\n          // normalize by the column\n          vec4 sum = vec4(0.0);\n          for ( float i = 0.0; i< " + f(heatmapWidth) + "; i++) {\n            float texelColumn = texelColumnStart + (i + 0.5) / " + f(reshapedWidth) + ";\n            for (float j = 0.0; j < " + f(heatmapHeight) + "; j++) {\n              float texelRow = texelRowStart + (j + 0.5) / " + f(reshapedHeight) + ";\n              vec4 value = texture2D(buffer, vec2(texelColumn, texelRow));\n              sum += value;\n            }\n          }\n          \n          ") + "\n      \n          // sum should be at least 1, prevents problems with empty buffers\n          gl_FragColor = max(vec4(1.0), sum);\n        }", uniforms: {
                    buffer: regl.prop("buffer"),
                }, framebuffer: regl.prop("out") }));
            normalize = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n        uniform sampler2D sums;\n        varying vec2 uv;\n      \n        void main() {\n          vec4 value = texture2D(buffer, uv);\n          vec4 sum = texture2D(sums, uv);\n      \n          " + (doNormalize
                    ? "gl_FragColor = value / sum;"
                    : "gl_FragColor = value;") + "\n        }", uniforms: {
                    sums: regl.prop("sums"),
                    buffer: regl.prop("buffer"),
                }, 
                // additive blending
                blend: {
                    enable: true,
                    func: {
                        srcRGB: "one",
                        srcAlpha: 1,
                        dstRGB: "one",
                        dstAlpha: 1,
                    },
                    equation: {
                        rgb: "add",
                        alpha: "add",
                    },
                    color: [0, 0, 0, 0],
                }, framebuffer: regl.prop("out") }));
            mergeBufferHorizontally = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n      \n        varying vec2 uv;\n      \n        void main() {\n          vec4 color = vec4(0);\n      \n          // collect all columns\n          for (float i = 0.0; i < " + f(repeatsX) + "; i++) {\n            float x = (i + uv.x) / " + f(repeatsX) + ";\n            color += texture2D(buffer, vec2(x, uv.y));\n          }\n      \n          gl_FragColor = color;\n        }", uniforms: {
                    buffer: regl.prop("buffer"),
                }, framebuffer: regl.prop("out") }));
            mergeBufferVertically = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n      \n        varying vec2 uv;\n      \n        void main() {\n          vec4 color = vec4(0);\n      \n          // collect all rows\n          for (float i = 0.0; i < " + f(repeatsY) + "; i++) {\n            float y = (i + uv.y) / " + f(repeatsY) + ";\n            color += texture2D(buffer, vec2(uv.x, y));\n          }\n      \n          float value = color.r + color.g + color.b + color.a;\n          gl_FragColor = vec4(vec3(value), 1.0);\n        }", uniforms: {
                    buffer: regl.prop("buffer"),
                }, framebuffer: regl.prop("out") }));
            drawTexture = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n        uniform float plasma[33];\n        uniform float maxi;\n        \n        varying vec2 uv;\n        \n        void main() {\n          // get r and draw it\n          float value = texture2D(buffer, uv).r;\n\n          if (value <= 0.01) {\n            gl_FragColor = vec4(0);\n          } else {\n            float normValue = value / maxi;\n            float step = 1.0 / 10.0;\n            for (int i = 0; i < 10; i++) {\n              if (normValue <= float(i + 1) * step) {\n                float rangeValue = (normValue - float(i) * step) * 10.0;\n                vec3 aColor = vec3(plasma[i * 3 + 0], plasma[i * 3 + 1], plasma[i * 3 + 2]);\n                vec3 bColor = vec3(plasma[(i + 1) * 3 + 0], plasma[(i + 1) * 3 + 1], plasma[(i + 1) * 3 + 2]);\n                gl_FragColor = vec4(aColor * (1.0 - rangeValue) + bColor * rangeValue, 1.0);\n                return;\n              }\n            }\n            gl_FragColor = vec4(plasma[30], plasma[31], plasma[32], 1);\n          }\n        }", uniforms: __assign({ buffer: regl.prop("buffer"), maxi: regl.prop("maxi") }, [
                    [0.9882352941176471, 0.9921568627450981, 0.7490196078431373],
                    [0.996078431372549, 0.807843137254902, 0.5686274509803921],
                    [0.996078431372549, 0.6235294117647059, 0.42745098039215684],
                    [0.9686274509803922, 0.43529411764705883, 0.3607843137254902],
                    [0.8705882352941177, 0.28627450980392155, 0.40784313725490196],
                    [0.7137254901960784, 0.21568627450980393, 0.47843137254901963],
                    [0.5490196078431373, 0.1607843137254902, 0.5058823529411764],
                    [0.396078431372549, 0.10196078431372549, 0.5019607843137255],
                    [0.23137254901960785, 0.058823529411764705, 0.4392156862745098],
                    [0.08235294117647059, 0.054901960784313725, 0.21568627450980393],
                    [0, 0, 0.01568627450980392],
                ]
                    // ...[
                    //   [0.9411764705882353, 0.9764705882352941, 0.12941176470588237],
                    //   [0.9882352941176471, 0.807843137254902, 0.1450980392156863],
                    //   [0.9882352941176471, 0.6509803921568628, 0.21176470588235294],
                    //   [0.9490196078431372, 0.5137254901960784, 0.2980392156862745],
                    //   [0.8823529411764706, 0.39215686274509803, 0.3843137254901961],
                    //   [0.796078431372549, 0.2784313725490196, 0.4745098039215686],
                    //   [0.6941176470588235, 0.16470588235294117, 0.5647058823529412],
                    //   [0.5647058823529412, 0.050980392156862744, 0.6431372549019608],
                    //   [0.41568627450980394, 0, 0.6588235294117647],
                    //   [0.25882352941176473, 0.011764705882352941, 0.615686274509804],
                    //   [0.050980392156862744, 0.03137254901960784, 0.5294117647058824],
                    // ]
                    .reduce(function (p, v) { return __spread(p, v); }, [])
                    .reduce(function (p, v, i) {
                    var _a;
                    return __assign(__assign({}, p), (_a = {}, _a["plasma[" + i + "]"] = v, _a));
                }, {})) }));
            filterByAngles = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n        uniform float startTime;\n        uniform float endTime;\n        uniform float startAngle;\n        uniform float endAngle;\n        \n        varying vec2 uv;\n        \n        void main() {\n          // get r and draw it\n          float width = " + f(heatmapWidth) + ";\n          float height = " + f(heatmapHeight) + ";\n          float start = startTime * width;\n          float end = endTime * width;\n          vec4 result = vec4(1);\n          vec4 valid = vec4(0);\n          for (float pointer = 0.0;pointer<=" + f(heatmapWidth) + ";pointer++){\n            if (pointer >= start && pointer <= end){\n              vec4 angle = texture2D(buffer, vec2((pointer + 0.5) / width, uv.y));\n              for (float pointer2 = 0.0;pointer2<=" + f(heatmapWidth) + ";pointer2++){\n                if (pointer2 > pointer && pointer2 <= end){\n                  vec4 angle2 = texture2D(buffer, vec2((pointer2 + 0.5) / width, uv.y));\n                  float diff = 0.0;\n                  " + [0, 1, 2, 3]
                    .map(function (i) { return "\n                  if(angle2[" + i + "] > 0.0) {\n                    valid[" + i + "] = 1.0;\n                  }\n                  diff = (angle2[" + i + "] - angle[" + i + "]) * 500.0 / (pointer2 - pointer) * width / 1000.0;\n                  if (diff < startAngle || diff > endAngle) {\n                    result[" + i + "] = 0.0;\n                  }\n                  "; })
                    .join("") + "\n                }\n              }\n            }\n          }\n          " + [0, 1, 2, 3]
                    .map(function (i) { return "\n          if(valid[" + i + "] <= 0.0) {\n            result[" + i + "] = 0.0;\n          }\n          "; })
                    .join("") + "\n          gl_FragColor = result;\n        }", uniforms: {
                    buffer: regl.prop("buffer"),
                    startTime: regl.prop("startTime"),
                    endTime: regl.prop("endTime"),
                    startAngle: regl.prop("startAngle"),
                    endAngle: regl.prop("endAngle"),
                }, framebuffer: regl.prop("out") }));
            filterByValues = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n        uniform float startTime;\n        uniform float endTime;\n        uniform float startValue;\n        uniform float endValue;\n        \n        varying vec2 uv;\n        \n        void main() {\n          // get r and draw it\n          float width = " + f(heatmapWidth) + ";\n          float start = startTime * width;\n          float end = endTime * width;\n          vec4 result = vec4(0);\n          for (float pointer = 0.0;pointer<=" + f(heatmapWidth) + ";pointer++){\n            if (pointer >= start && pointer <= end){\n              vec4 angle = texture2D(buffer, vec2((pointer + 0.5) / width, uv.y));\n              " + [0, 1, 2, 3]
                    .map(function (i) { return "\n              if (angle[" + i + "] >= startValue && angle[" + i + "] <= endValue) {\n                result[" + i + "] = 1.0;\n              }\n              "; })
                    .join("") + "\n            }\n          }\n          gl_FragColor = result;\n        }", uniforms: {
                    buffer: regl.prop("buffer"),
                    startTime: regl.prop("startTime"),
                    endTime: regl.prop("endTime"),
                    startValue: regl.prop("startValue"),
                    endValue: regl.prop("endValue"),
                }, framebuffer: regl.prop("out") }));
            findMax = regl(__assign(__assign({}, computeBase), { frag: "\n        precision mediump float;\n      \n        uniform sampler2D buffer;\n        \n        varying vec2 uv;\n        \n        void main() {\n          float width = " + f(heatmapWidth) + ";\n          float height = " + f(heatmapHeight) + ";\n          vec4 result = vec4(0);\n          for (float x = 0.0;x<=" + f(heatmapWidth) + ";x++){\n            for (float y = 0.0;y<=" + f(heatmapHeight) + ";y++){\n              result = max(result, texture2D(buffer, vec2(x / width, y / height)));\n            }\n          }\n          gl_FragColor = result;\n        }", uniforms: {
                    buffer: regl.prop("buffer"),
                }, framebuffer: regl.prop("out") }));
            calWeight = regl(__assign(__assign({}, computeBase), { frag: "\n    precision mediump float;\n      \n    uniform sampler2D buffer;\n    uniform sampler2D heat;\n    \n    varying vec2 uv;\n    \n    void main() {\n      float width = " + f(heatmapWidth) + ";\n      float height = " + f(heatmapHeight) + ";\n      vec4 sum = vec4(0);\n      for (float i = 0.0; i< " + f(heatmapWidth) + ";i++){\n        vec4 pointer = texture2D(buffer, vec2(i / width, uv.y));\n        " + [0, 1, 2, 3]
                    .map(function (i) { return "\n        sum[" + i + "] += texture2D(heat, vec2(i / width, pointer[" + i + "])).x;\n        "; })
                    .join("") + "\n      }\n      gl_FragColor = sum;\n    }\n    ", uniforms: {
                    buffer: regl.prop("buffer"),
                    heat: regl.prop("heat"),
                }, framebuffer: regl.prop("out") }));
            console.time("Allocate buffers");
            linesBuffer = regl.framebuffer({
                width: reshapedWidth,
                height: reshapedHeight,
                colorFormat: "rgba",
                colorType: "uint8",
            });
            gaussianBuffer = regl.framebuffer({
                width: reshapedWidth,
                height: reshapedHeight,
                colorFormat: "rgba",
                colorType: "float",
            });
            flatLinesBuffer = regl.framebuffer({
                width: heatmapWidth,
                height: Math.ceil(data.length / 4),
                colorFormat: "rgba",
                colorType: "float",
            });
            filterAngleBuffer = regl.framebuffer({
                width: 1,
                height: Math.ceil(data.length / 4),
                colorFormat: "rgba",
                colorType: "float",
            });
            sumsBuffer = regl.framebuffer({
                width: reshapedWidth,
                height: repeatsY,
                colorFormat: "rgba",
                colorType: "float",
            });
            resultBuffer = regl.framebuffer({
                width: reshapedWidth,
                height: reshapedHeight,
                colorFormat: "rgba",
                colorType: "float",
            });
            preMergedBuffer = regl.framebuffer({
                width: heatmapWidth,
                height: reshapedHeight,
                colorFormat: "rgba",
                colorType: "float",
            });
            heatBuffer = regl.framebuffer({
                width: heatmapWidth,
                height: heatmapHeight,
                colorFormat: "rgba",
                colorType: "float",
            });
            maxValueBuffer = regl.framebuffer({
                width: 1,
                height: 1,
                colorFormat: "rgba",
                colorType: "float",
            });
            console.timeEnd("Allocate buffers");
            console.time("Compute heatmap");
            batchSize = 4 * repeatsX * repeatsY;
            series = 0;
            finishedSeries = 0;
            regl.clear({
                color: [0, 0, 0, 0],
                framebuffer: flatLinesBuffer,
            });
            for (b = 0; b < numSeries; b += batchSize) {
                console.time("Prepare Batch");
                lines = new Array(Math.min(batchSize, numSeries - series));
                // clear the lines buffer before the next batch
                regl.clear({
                    color: [0, 0, 0, 0],
                    framebuffer: linesBuffer,
                });
                loop: for (row = 0; row < repeatsY; row++) {
                    for (i = 0; i < 4 * repeatsX; i++) {
                        if (series >= numSeries) {
                            break loop;
                        }
                        valueLength = data[series].xValues.length;
                        lines[series - finishedSeries] = {
                            values: ndarray(data[series].yValues),
                            times: ndarray(data[series].xValues),
                            maxY: binY.stop,
                            maxX: maxDataPoints,
                            lineIdx: series,
                            column: Math.floor(i / 4),
                            row: row,
                            colorMask: colorMask(i),
                            count: valueLength,
                            out: linesBuffer,
                            flatOut: flatLinesBuffer,
                        };
                        series++;
                    }
                }
                console.timeEnd("Prepare Batch");
                console.info("Drawing " + lines.length + " lines.");
                console.time("regl: drawFlatLine");
                drawFlatLine(lines);
                console.timeEnd("regl: drawFlatLine");
                console.time("regl: drawLine");
                drawLine(lines);
                console.timeEnd("regl: drawLine");
                console.time("regl: gaussian");
                gaussian({
                    buffer: linesBuffer,
                    out: gaussianBuffer,
                });
                console.timeEnd("regl: gaussian");
                finishedSeries += lines.length;
                console.time("regl: sum");
                sum({
                    buffer: gaussianBuffer,
                    out: sumsBuffer,
                });
                console.timeEnd("regl: sum");
                console.time("regl: normalize");
                normalize({
                    buffer: gaussianBuffer,
                    sums: sumsBuffer,
                    out: resultBuffer,
                });
                console.timeEnd("regl: normalize");
            }
            console.time("regl: merge");
            mergeBufferHorizontally({
                buffer: resultBuffer,
                out: preMergedBuffer,
            });
            mergeBufferVertically({
                buffer: preMergedBuffer,
                out: heatBuffer,
            });
            console.timeEnd("regl: merge");
            console.timeEnd("Compute heatmap");
            console.time("regl: findMax");
            findMax({
                buffer: heatBuffer,
                out: maxValueBuffer,
            });
            maxDensity = Math.ceil(regl.read({ framebuffer: maxValueBuffer })[0]);
            console.timeEnd("regl: findMax");
            console.log("max density is:", maxDensity);
            drawTexture({
                buffer: heatBuffer,
                maxi: maxDensity,
            });
            indexCache = range(data.length);
            return [2 /*return*/, {
                    filterAngle: function (startTime, endTime, startAngle, endAngle) {
                        var _a, _b;
                        console.time("compute angle range");
                        _a = __read(slope([startTime, endTime], 0, 1), 2), startTime = _a[0], endTime = _a[1];
                        _b = __read(slope([startAngle, endAngle], -90, 90), 2), startAngle = _b[0], endAngle = _b[1];
                        filterByAngles({
                            buffer: flatLinesBuffer,
                            out: filterAngleBuffer,
                            startTime: startTime,
                            endTime: endTime,
                            startAngle: startAngle,
                            endAngle: endAngle,
                        });
                        var filterResult = regl.read({ framebuffer: filterAngleBuffer });
                        console.timeEnd("compute angle range");
                        return new Float32Array(filterResult)
                            .map(function (x, i) { return (x ? i + 1 : 0); })
                            .filter(function (x) { return x; })
                            .map(function (x) { return x - 1; });
                    },
                    filterRange: function (startTime, endTime, startValue, endValue) {
                        var _a;
                        console.time("compute rect range");
                        _a = __read(slope([startTime, endTime, startValue, endValue], 0, 1), 4), startTime = _a[0], endTime = _a[1], startValue = _a[2], endValue = _a[3];
                        filterByValues({
                            buffer: flatLinesBuffer,
                            out: filterAngleBuffer,
                            startTime: startTime,
                            endTime: endTime,
                            startValue: startValue,
                            endValue: endValue,
                        });
                        var filterResult = regl.read({ framebuffer: filterAngleBuffer });
                        console.timeEnd("compute rect range");
                        return new Float32Array(filterResult)
                            .map(function (x, i) { return (x ? i + 1 : 0); })
                            .filter(function (x) { return x; })
                            .map(function (x) { return x - 1; });
                    },
                    findKTop: function (isHighest, diverse) {
                        console.time("find-top");
                        console.time("regl: calWeight");
                        calWeight({
                            buffer: flatLinesBuffer,
                            heat: heatBuffer,
                            out: filterAngleBuffer,
                        });
                        var weights = __spread(regl.read({ framebuffer: filterAngleBuffer })).map(function (w, i) {
                            if (!data[i])
                                return { w: 0, i: i };
                            return { w: w, i: i };
                        })
                            .filter(function (o) { return indexCache.includes(o.i); })
                            .sort(function (a, b) { return (isHighest ? b.w - a.w : a.w - b.w); });
                        console.timeEnd("regl: calWeight");
                        if (isHighest && diverse) {
                            var diversityList = [];
                            for (var i = 0; diversityList.length < 3 && i < weights.length; i++) {
                                var flag = true;
                                var _loop_1 = function (j) {
                                    var insertLine = data[weights[i].i];
                                    var testLine = data[diversityList[j]];
                                    var testLength = Math.min(insertLine.xValues.length, testLine.xValues.length);
                                    var subArr = insertLine.yValues
                                        .slice(insertLine.yValues.length - testLength)
                                        .map(function (v, i) {
                                        return (v -
                                            testLine.yValues[testLine.yValues.length - testLength + i]) /
                                            binY.stop;
                                    });
                                    if (standardDeviation(subArr) < diverse) {
                                        flag = false;
                                        return "break";
                                    }
                                };
                                for (var j = 0; j < diversityList.length; j++) {
                                    var state_1 = _loop_1(j);
                                    if (state_1 === "break")
                                        break;
                                }
                                if (flag) {
                                    diversityList.push(weights[i].i);
                                }
                            }
                            console.timeEnd("find-top");
                            return diversityList;
                        }
                        else {
                            console.timeEnd("find-top");
                            return weights.slice(0, 3).map(function (o) { return o.i; });
                        }
                    },
                    rerender: function (indexes) {
                        if (!indexes) {
                            indexes = range(data.length);
                        }
                        indexCache = indexes;
                        console.time("Compute heatmap");
                        // batches of 4 * repeats
                        var batchSize = 4 * repeatsX * repeatsY;
                        // index of series
                        var series = 0;
                        // how many series have already been drawn
                        var finishedSeries = 0;
                        regl.clear({
                            color: [0, 0, 0, 0],
                            framebuffer: resultBuffer,
                        });
                        for (var b = 0; b < indexes.length; b += batchSize) {
                            console.time("Prepare Batch");
                            // array to hold the lines that should be rendered
                            var lines = new Array(Math.min(batchSize, indexes.length - series));
                            // clear the lines buffer before the next batch
                            regl.clear({
                                color: [0, 0, 0, 0],
                                framebuffer: linesBuffer,
                            });
                            loop2: for (var row = 0; row < repeatsY; row++) {
                                for (var i = 0; i < 4 * repeatsX; i++) {
                                    if (series >= indexes.length) {
                                        break loop2;
                                    }
                                    // console.log(series, Math.floor(i / 4), row);
                                    var valueLength = data[indexes[series]].xValues.length;
                                    lines[series - finishedSeries] = {
                                        values: ndarray(data[indexes[series]].yValues),
                                        times: ndarray(data[indexes[series]].xValues),
                                        maxY: binY.stop,
                                        maxX: maxDataPoints,
                                        column: Math.floor(i / 4),
                                        row: row,
                                        colorMask: colorMask(i),
                                        count: valueLength,
                                        out: linesBuffer,
                                    };
                                    series++;
                                }
                            }
                            console.timeEnd("Prepare Batch");
                            console.info("Drawing " + lines.length + " lines.");
                            console.time("regl: drawLine");
                            drawLine(lines);
                            console.timeEnd("regl: drawLine");
                            console.time("regl: gaussian");
                            gaussian({
                                buffer: linesBuffer,
                                out: gaussianBuffer,
                            });
                            console.timeEnd("regl: gaussian");
                            finishedSeries += lines.length;
                            console.time("regl: sum");
                            sum({
                                buffer: gaussianBuffer,
                                out: sumsBuffer,
                            });
                            console.timeEnd("regl: sum");
                            console.time("regl: normalize");
                            normalize({
                                buffer: gaussianBuffer,
                                sums: sumsBuffer,
                                out: resultBuffer,
                            });
                            console.timeEnd("regl: normalize");
                        }
                        console.time("regl: merge");
                        mergeBufferHorizontally({
                            buffer: resultBuffer,
                            out: preMergedBuffer,
                        });
                        mergeBufferVertically({
                            buffer: preMergedBuffer,
                            out: heatBuffer,
                        });
                        console.timeEnd("regl: merge");
                        console.timeEnd("Compute heatmap");
                        drawTexture({
                            buffer: heatBuffer,
                            maxi: maxDensity,
                        });
                    },
                    destroy: function () {
                        regl.destroy();
                    },
                    get maxDensity() {
                        return maxDensity;
                    },
                    set maxDensity(v) {
                        if (maxDensity == v || v < 1)
                            return;
                        maxDensity = v;
                        drawTexture({
                            buffer: heatBuffer,
                            maxi: maxDensity,
                        });
                    },
                    maxX: binX.stop,
                    maxY: binY.stop,
                }];
        });
    });
}
function standardDeviation(values) {
    var avg = average(values);
    var squareDiffs = values.map(function (value) {
        var diff = value - avg;
        var sqrDiff = diff * diff;
        return sqrDiff;
    });
    var avgSquareDiff = average(squareDiffs);
    var stdDev = Math.sqrt(avgSquareDiff);
    return stdDev;
}
function average(data) {
    var sum = data.reduce(function (sum, value) {
        return sum + value;
    }, 0);
    var avg = sum / data.length;
    return avg;
}
